module.exports = __webpack_public_path__ + "img/collaborate_59.42d55686.jpg";